import { priceComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';
import { Fee } from 'generated/graphql';

const CheapestItineraryBuilder = () => {
  let cheapestPosition;
  let cheapest: Fee = {
    price: {
      amount: Infinity,
      currency: '',
    },
    type: {
      id: '',
      name: '',
    },
  };

  return {
    add(itinerary: Fee, position: number) {
      if (priceComparator(itinerary, cheapest) < 0) {
        cheapest = itinerary;
        cheapestPosition = position;
      }
    },
    build() {
      return createBestItineraryData('cheapest', cheapest, cheapestPosition);
    },
  };
};

export default CheapestItineraryBuilder;
